import type { Mission } from '../missions.ts'

export const usms: Mission = {
  id: "usms",
  name: "U.S. Marshals Service",
  short: "USMS",
  call: "Marshals",
  kind: "subagency",
  parent: "doj",
  url: "https://www.usmarshals.gov/",
  established: 1789,
  palette: {
    primary: "#004785",
    secondary: "#9a6b38",
    accent: "#e38d1a",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Marshals_Service.svg",
  },
  motif: "star",
  mission: {
    text: "The mission of the U.S. Marshals Service is to enforce federal laws and provide support to virtually all elements of the federal justice system by providing for the security of federal court facilities and the safety of judges and other court personnel; apprehending criminals; exercising custody of federal prisoners and providing for their security and transportation to correctional facilities; executing federal court orders; seizing assets gained by illegal means and providing for the custody, management, and disposal of forfeited assets; assuring the safety of endangered government witnesses and their families; and collecting and disbursing funds.",
    url: "https://www.usmarshals.gov/who-we-are/about-us",
  },
  fact: {
    text: "The offices of U.S. Marshal were created by the Judiciary Act of 1789, which George Washington considered of premier importance to the new nation.",
    url: "https://www.usmarshals.gov/who-we-are/history",
  },
  seal: {
    file: "public/seals/usms.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Marshals_Service.svg",
  },
  identifier: {
    about: "https://www.usmarshals.gov/who-we-are/about-us",
    accessibility: "https://www.usmarshals.gov/accessibility",
    foia: "https://www.usmarshals.gov/freedom-of-information-act",
    noFear: "https://www.justice.gov/jmd/eeo-program-status-report",
    oig: "https://oig.justice.gov/",
    performance: "https://www.usmarshals.gov/budget-and-performance",
    privacy: "https://www.usmarshals.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/usms-north-star-night.jpg",
        small: "/media/usms-north-star-night-sm.jpg",
        alt: "Deputy marshals in tactical vests stand behind parked cars at night, one aiming a flashlight-mounted rifle toward a house.",
        title: "Operation North Star fugitive apprehension, Baton Rouge, Louisiana, September 10, 2024",
        creator: "U.S. Marshals Service",
        source: "https://commons.wikimedia.org/wiki/File:Operation_North_Star_24_Baton_Rouge-2.jpg",
        license: "CC BY 2.0",
      },
      {
        file: "/media/usms-north-star-day.jpg",
        small: "/media/usms-north-star-day-sm.jpg",
        alt: "Deputy marshals in tactical vests stand on a residential driveway beside two black SUVs during a morning operation.",
        title: "Operation North Star fugitive apprehension, Baton Rouge, Louisiana, September 12, 2024",
        creator: "U.S. Marshals Service",
        source: "https://commons.wikimedia.org/wiki/File:Operation_North_Star_24_Baton_Rouge-20.jpg",
        license: "CC BY 2.0",
      },
    ],
  },
}
